/** `(___) ___-____` is 14 characters once formatted. */
export const PHONE_NUMBER_MAX_LENGTH = 14;
